const Spezies = () => {
    return {
        valide: null,
        de: '',
        wiss: '',
        touched: false,
        einordnung: [],
        istVogel: false,
        istSaeugetier: false,
        istFisch: false,
        istReptil: false,
        istSpinne: false,
        istSchildkroete: false,
        istElefant: false,
        anhangA: false,
        anhangB: false,
        istFlora: false,
        istFauna: false,


        washintonerArtenschutzabkommen:null,
        egVerordnung:null,
        bundesnaturschutzgesetz:null,
        meldepflichtig:null,

        species:null,
        abteilung:null,
        unterabteilung:null,
        klasse:null,
        unterklasse:null,
        ordnung:null,
        familie:null,
        unterfamilie:null,
        art:null
    }
}
export default Spezies;